'use client';

import bannerImage from '@/assets/images/try-on-page/banner.png';
import benefitsImage from '@/assets/images/try-on-page/benefits.png';
import how1 from '@/assets/images/try-on-page/how-1.svg';
import how2 from '@/assets/images/try-on-page/how-2.svg';
import how3 from '@/assets/images/try-on-page/how-3.svg';
import how4 from '@/assets/images/try-on-page/how-4.svg';
import mobileBannerImage from '@/assets/images/try-on-page/mobile-banner.png';
import mobileBenefitsImage from '@/assets/images/try-on-page/mobile-benefits.png';
import GalleryItem from '@/components/Gallery/item';
import SampleNextArrow from '@/components/SampleNextArrow';
import SamplePrevArrow from '@/components/SamplePrevArrow';
import { useTryOnPage } from '@/hooks/TryOnPage/useTryOnPage';
import useIsMobile from '@/hooks/use-is-mobile';
import Image from 'next/image';
import Link from 'next/link';
import Slider from 'react-slick';
import classes from './tryOnPage.module.css';

export const TryOnPage = () => {
  const isMobile = useIsMobile();

  const talonProps = useTryOnPage({});

  const { products, storeConfig } = talonProps;

  const sliderProps = {
    dots: !!isMobile,
    infinite: false,
    showArrows: false,
    slidesToShow: isMobile ? 2 : 6,
    arrows: !isMobile,
    nextArrow: isMobile ? null : <SampleNextArrow className={'nextarrow'} />,
    prevArrow: isMobile ? null : <SamplePrevArrow className={'prevarrow'} />,
    slidesToScroll: isMobile ? 1 : 3,
    margin: '10px',
  };

  // const onClick = useCallback(() => {
  //     router.push('/sample-dresses/')
  // }, [router])

  return (
    <div className={classes.root}>
      <div className={classes.banner}>
        <Image
          src={isMobile ? mobileBannerImage : bannerImage}
          className={classes.bannerImage}
          loading='lazy'
          alt=''
        />
        <div className={classes.bannerContent}>
          <h2 className={classes.bannerTitle}>Home Try-On</h2>
          <p className={classes.bannerInfo}>Try our dresses at home, and enjoy free shipping. </p>
          <Link
            className={classes.bannerButton}
            href={'/sample-dresses'}
          >
            FIND MORE DRESSES
          </Link>
        </div>
      </div>
      <div className={classes.howItWorks}>
        <h2 className={classes.howItWorksTitle}>How it works?</h2>
        <ul className={classes.howContainer}>
          <li className={classes.howItem}>
            <Image
              src={how1}
              className={classes.itemImage}
              alt=''
            />
            <p className={classes.itemTitle}>Pick your dresses</p>
            <p className={classes.itemInfo}>
              Pick 1-3 dresses, you could try on at home for 5 days. Shipping and return are free.
            </p>
          </li>
          <li className={classes.howItem}>
            <Image
              src={how2}
              className={classes.itemImage}
              alt=''
            />
            <p className={classes.itemTitle}>Try on at home</p>
            <p className={classes.itemInfo}>Try on the dresses at home comfortably.</p>
          </li>
          <li className={classes.howItem}>
            <Image
              src={how3}
              className={classes.itemImage}
              alt=''
            />
            <p className={classes.itemTitle}>Mail dresses Back</p>
            <p className={classes.itemInfo}>
              Download the return lable in our website, return your dresses within 5 days after receiving your package.
            </p>
          </li>
          <li className={classes.howItem}>
            <Image
              src={how4}
              className={classes.itemImage}
              alt=''
            />
            <p className={classes.itemTitle}>Buy your dresses</p>
            <p className={classes.itemInfo}>
              After try on the dresses, order your fit size and colors or custom dresses for free in our website.
            </p>
          </li>
        </ul>

        <Link
          className={classes.findMoreButton}
          href={'/sample-dresses'}
        >
          FIND MORE DRESSES
        </Link>
      </div>
      <div className={classes.benefits}>
        <Image
          src={isMobile ? mobileBenefitsImage : benefitsImage}
          className={classes.benefitsImage}
          loading='lazy'
          alt=''
        />
        <div className={classes.benefitsContent}>
          <h2 className={classes.benefitsTitle}>3 key benefites</h2>
          <ul className={classes.benefitsList}>
            <li className={classes.benefitsListItem}>
              1. You don't need to worry about getting the right size because trying it on at home makes it easier to
              know the size.
            </li>
            <li className={classes.benefitsListItem}>
              2. Try it on at home to experience the dresses more personally, to get the most realistic wearing
              experience.
            </li>
            <li className={classes.benefitsListItem}>
              3. We provide you try on dresses with free shipping and return. No worries about shipping and return.
            </li>
          </ul>
        </div>
      </div>
      <div className={classes.hotStyle}>
        <h2 className={classes.hotStyleTitle}>Hot Style Bridesmaids</h2>
        <div className={classes.productList}>
          <Slider {...sliderProps}>
            {products?.map(product => {
              return (
                <div
                  className={classes.itemContainer}
                  key={product.id}
                >
                  <GalleryItem
                    key={product.id}
                    item={product}
                    storeConfig={storeConfig}
                    showCustomizeOptions={false}
                    showReview={false}
                    freeShipping={true}
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
      <div className={classes.faq}>
        <h2 className={classes.faqTitle}>Frequently Asked Questions</h2>

        <div className={classes.faqList}>
          <div className={classes.faqItem}>
            <div className={classes.question}>What is home try-on?</div>
            <div className={classes.answer}>
              Home Try-On is an exclusive program where you can try before you buy from eligible items in our website.
              You get up-to 5 days try-on period beginning the day after delivery to try-on the items at home.
            </div>
          </div>
          <div className={classes.faqItem}>
            <div className={classes.question}>What items are eligible for home try-on? </div>
            <div className={classes.answer}>
              We provide bridesmaid dresses to try on. You could find{' '}
              <Link
                href='/sample-dresses'
                target='_blank'
              >
                here
              </Link>
              .
            </div>
          </div>

          <div className={classes.faqItem}>
            <div className={classes.question}>How much does home try on dresses cost?</div>
            <div className={classes.answer}>
              Each bridesmaid dress is $10. You could choose 1-3 dresses to try on and enjoy free shipping and return.
            </div>
          </div>

          <div className={classes.faqItem}>
            <div className={classes.question}>How many items can I try at one time?</div>
            <div className={classes.answer}>We suggest you could pick 1-3 dresses to try.</div>
          </div>

          <div className={classes.faqItem}>
            <div className={classes.question}>Where can the try-on items be delivered? </div>
            <div className={classes.answer}>
              We could ship to United States. So the items you return must be from United States.{' '}
            </div>
          </div>

          <div className={classes.faqItem}>
            <div className={classes.question}>How long does it take for my home try-on dresses to arrive? </div>
            <div className={classes.answer}>
              Usually it will take about 2 to 6 days to arrive on you. When your parcel is shipped, you will receive the
              confirmation email. You could check the shipping information.
            </div>
          </div>

          <div className={classes.faqItem}>
            <div className={classes.question}>How long is the try-on period?</div>
            <div className={classes.answer}>
              After you receive the parcel, you could try on the dresses 5 days at home. Then you need to return the
              parcel.
            </div>
          </div>

          <div className={classes.faqItem}>
            <div className={classes.question}>How do I return my home try on dresses? </div>
            <div className={classes.answer}>
              Please keep the items in their original packaging with all tags attached. You can download the return
              label from our website and return your dresses within 5 days of receiving your package.
            </div>
          </div>

          <div className={classes.faqItem}>
            <div className={classes.question}>What happens if I forget to send back my dresses within 5 days? </div>
            <div className={classes.answer}>
              Please return the items in time. If you are unable to return the items in time, please send us email and
              we could help you.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TryOnPage;
